/**
 *
 * PriceInput
 *
 */

import React from 'react';

import { FlexInput } from 'components/common';

const formatPrice = (val, reformat) => {
  let originalValue = val;
  if (reformat) {
    if (!val || val === '') {
      val = 0;
    } else {
      val = val.replace(/,/g, '');
    }
    val = parseFloat(val).toLocaleString('en-US', {
      style: 'decimal',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  } else {
    val = originalValue;
  }

  return val;
};

function PriceInput(props) {
  const { onBlur, onChange } = props;
  const handleOnBlur = e => {
    let val = formatPrice(e.target.value, true);
    let valPennies;
    if (typeof val === 'string') {
      valPennies = val.replace(/,/g, '');
      valPennies = parseFloat(valPennies) * 100;
    }

    if (onBlur) {
      onBlur(val, valPennies);
    }
  };

  const handleOnChange = e => {
    let val = formatPrice(e.target.value, false);
    if (onChange) {
      onChange(val);
    }
  };

  let value = props.value;
  if (value != null) {
    if (typeof value === 'number') {
      value = (value / 100.0).toFixed(2) + '';
    }
  }

  return (
    <FlexInput
      {...props}
      value={value}
      label="$"
      labelPosition="left"
      onBlur={handleOnBlur}
      onChange={handleOnChange}
    />
  );
}

PriceInput.propTypes = {};

export default PriceInput;
